'use strict';

var StatementBoxController = function StatementBoxController($scope, statementBoxService) {
  $scope.statement = '';
  $scope.updateStatement = function () {
    $scope.statement = statementBoxService.formatStatement($scope.rule, $scope.strategy, $scope.strategyGroup);
  };
};
StatementBoxController.$inject = ['$scope', 'StatementBoxService'];
module.exports = StatementBoxController;